const TEXT_ANIMATION_FONT_WAIT_MAX_MS = 1000

let fontsReadyPromise = null
let fontsAreReady = false
let boundedFontWaitPromise = null

function getFontsReadyPromise() {
	if (fontsReadyPromise) {
		return fontsReadyPromise
	}

	if (typeof document === 'undefined' || !document.fonts || !document.fonts.ready) {
		fontsAreReady = true
		fontsReadyPromise = Promise.resolve()
		return fontsReadyPromise
	}

	fontsReadyPromise = Promise.resolve(document.fonts.ready)
		.catch(() => {})
		.then(() => {
			fontsAreReady = true
			boundedFontWaitPromise = null
		})

	return fontsReadyPromise
}

/**
 * Prefer splitting with the final webfonts, but never keep every animated
 * text hidden behind a slow FontFaceSet. Safari can leave document.fonts.ready
 * pending for several seconds when an unrelated third-party font is slow.
 *
 * @returns {Promise<boolean>} true when fonts settled before the timeout
 */
export function waitForTextAnimationFonts() {
	if (fontsAreReady) {
		return Promise.resolve(true)
	}

	const readyPromise = getFontsReadyPromise()
	if (fontsAreReady) {
		return Promise.resolve(true)
	}

	if (!boundedFontWaitPromise) {
		const timeoutPromise = new Promise((resolve) => {
			window.setTimeout(() => resolve(false), TEXT_ANIMATION_FONT_WAIT_MAX_MS)
		})
		boundedFontWaitPromise = Promise.race([
			readyPromise.then(() => true),
			timeoutPromise,
		])
	}

	return boundedFontWaitPromise
}

export function whenTextAnimationFontsAreReady() {
	return getFontsReadyPromise()
}
